import styled, { css } from 'styled-components';
import * as SearchSelector from './SearchSelector/styles';
import * as DateRangeSelector from './DateRangeSelector/styles';
import * as Navbar from './Navbar/styles';

export const Section = styled.div`
    z-index: 11;
    position: absolute;
    text-align: center;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    /* width: 970px;
    left: 50%;
    margin-left: -485px; */
`;

export const Title = styled.div`
    width: 100vw;
    text-shadow: 2px 2px 6px #000;
    color: #fff;
    font-size: 63px;
    font-weight: 500;
    line-height: 63px;
    position: relative;
    top: -40px;

    @media (max-width: 991px) {
        font-size: 41px;
        position: relative;
        top: -90px;
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ styles */
        top: 20px;
        width: 100%;
    }
`;

export const Subtitle = styled.div`
    width: 100%;
    min-height: 31px;
    text-shadow: 2px 2px 6px #000;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.6px;
    position: relative;
    top: -26px;

    @media (max-width: 991px) {
        position: relative;
        top: -90px;
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10+ styles */
        top: 20px;
        width: 100%;
    }
`;

export const SectionSearch = styled.div`
    position: absolute;
    bottom: 50px;
    width: 930px;
    left: 50%;
    margin-left: -465px;
    z-index: 12;
    border-radius: 40px;
    background-color: #1b374a;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
`;

export const SectionSearchInner = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    ${SearchSelector.SearchSelector} {
        width: 460px;
        margin-right: 20px;
    }

    ${DateRangeSelector.DateRangeSelector} {
        width: 310px;
        margin-right: 20px;
    }
    @media only screen and (min-width: 992px) and (max-width: 1220px) {
        ${SearchSelector.SearchSelector} {
            width: 340px;
        }
        ${DateRangeSelector.DateRangeSelector} {
            width: 430px;
        }
    }
`;

export const SectionCarousel = styled.div``;

export const GoButton = styled.button`
    font-size: 18px;
    line-height: 18px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 1.23px;
    font-family: Montserrat, Helvetica, Verdana, Arial, sans-serif;
    width: 80px;
    min-width: auto;
    height: 40px;
    background-color: #00b357;
    color: #fff;
    border-width: 2px;
    border-style: solid;
    border-color: #fff;
    border-image: initial;
    outline: none;
    transition: background-color 0.1s linear, color 0.1s linear, opacity 0.1s linear;
    padding: 5px;
    border-radius: 20px;

    ${(props) =>
        props.disabled
            ? css`
                  opacity: 0.7;
                  &:hover {
                      background-color: #00b357;
                      color: #fff;
                      opacity: 0.7;
                      cursor: initial;
                  }
              `
            : css`
                  opacity: 1;
                  &:hover {
                      background-color: #d2d2d2;
                      color: #333;
                      opacity: 1;
                      cursor: pointer;
                  }
              `}
`;

export const HeightLayer = styled.div`
    height: 80px;
`;

export const Header = styled.header`
    position: relative;

    ${(props) =>
        props.forceSimplify &&
        css`
            ${Navbar.Navbar} {
                box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 4px;
            }
            ${SectionSearch} {
                display: none;
                visibility: hidden;
            }
        `}

    @media only screen and (max-width: 991px) {
        & {
            box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 4px;
        }

        ${Navbar.Navbar} {
            position: relative;
            box-shadow: none;
            background-color: rgb(43, 59, 70);
            border-bottom: 0;
        }

        ${HeightLayer} {
            display: none;
            visibility: hidden;
        }

        ${SectionCarousel} {
            display: none;
            visibility: hidden;
        }

        ${SectionSearch} {
            width: 100%;
            margin-left: 0;
            left: 0;
            bottom: 0;
            position: relative;
            border-radius: 0;
            background-color: rgb(43, 59, 70);
        }

        ${SectionSearchInner} {
            flex-direction: column;
            align-items: center;

            ${SearchSelector.SearchSelector} {
                width: 100%;
                margin-right: 0;
                margin-bottom: 15px;
            }

            ${DateRangeSelector.DateRangeSelector} {
                width: 100%;
                margin-right: 0;
                margin-bottom: 15px;
            }
        }

        ${(props) =>
            (props.forceSimplify || props.forceSimplifyMobile) &&
            css`
                ${Navbar.Navbar} {
                    box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 4px;
                }
                ${SectionSearch} {
                    display: none;
                    visibility: hidden;
                }
            `}
    }

    @media only screen and (min-width: 992px) and (max-width: 1199px) {
        ${(props) => css`
            ${props.transparent &&
                css`
                    ${Navbar.Navbar} {
                        background-color: transparent;
                        box-shadow: none;
                    }
                `}

            ${props.fixed &&
                css`
                    ${Navbar.Navbar} {
                        position: fixed;
                        z-index: 20;
                        top: 0;
                    }
                `}

            ${!props.transparent &&
                css`
                    ${SectionSearch} {
                        z-index: 101;
                        box-shadow: none;
                        background: transparent;
                        position: fixed;
                        bottom: initial;
                        top: 0px;
                        height: 80px;
                    }
                `}
        `}
    }

    @media only screen and (min-width: 1200px) {
        ${(props) => css`
                ${props.transparent &&
                    css`
                        ${Navbar.Navbar} {
                            background-color: transparent;
                            box-shadow: none;
                        }
                    `}

                ${props.fixed &&
                    css`
                        ${Navbar.Navbar} {
                            position: fixed;
                            z-index: 20;
                            top: 0;
                        }
                    `}

                ${!props.transparent &&
                    css`
                        ${SectionSearch} {
                            z-index: 101;
                            box-shadow: none;
                            background: transparent;
                            position: fixed;
                            bottom: initial;
                            top: 0px;
                            height: 80px;
                        }
                    `}
            `};
    }

    @media only screen and (min-width: 992px) {
        ${(props) =>
            !props.transparent &&
            css`
                ${SectionSearch} {
                    left: 50%;
                    width: 680px;
                    margin-left: -265px;
                }
                ${SearchSelector.SearchSelector} {
                    width: 287px;
                    margin-right: 0px;
                }
                ${SearchSelector.Selector} {
                    width: 265px;
                }
                ${DateRangeSelector.Selector} {
                    width: 218px;
                }
                ${DateRangeSelector.DateRangeSelector} {
                    width: 241px;
                    margin-right: 0px;
                }
            `}
    }

    @media only screen and (min-width: 1280px) {
        ${(props) =>
            !props.transparent &&
            css`
                ${SectionSearch} {
                    left: 50%;
                    width: 831px;
                    margin-left: -380px;
                }
                ${SearchSelector.Selector} {
                    width: 423px;
                }
                ${SearchSelector.SearchSelector} {
                    margin-right: 10px;
                    width: 437px;
                }
                ${DateRangeSelector.Selector} {
                    width: 233px;
                }
                ${DateRangeSelector.DateRangeSelector} {
                    width: 247px;
                    margin-right: 17px;
                }
            `}
    }
    @media only screen and (min-width: 1420px) {
        ${(props) =>
            !props.transparent &&
            css`
                ${SectionSearch} {
                    margin-left: -400px;
                }
            `}
    }
    @media only screen and (min-width: 1560px) {
        ${(props) => !props.transparent && css``}
    }
`;
